export default {
  list: [],
  listLoading: true,
  record: null,
  recordLoading: true,
  totalCount: 0
}
